import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as CacheService from "../../services/Cache";

// Initial state
const initialState = {
  clearCacheLoading: false,
  clearCacheError: null,
  lastClearResult: null,
};

// Async thunks
export const clearSiteCache = createAsyncThunk(
  "cache/clearSiteCache",
  async (siteId, { rejectWithValue }) => {
    try {
      const response = await CacheService.clearSiteCache(siteId);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to clear cache"
      );
    }
  }
);

export const clearSpecificCache = createAsyncThunk(
  "cache/clearSpecificCache",
  async ({ siteId, cacheType }, { rejectWithValue }) => {
    try {
      const response = await CacheService.clearSpecificCache(siteId, cacheType);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Failed to clear specific cache"
      );
    }
  }
);

// Slice
const cacheSlice = createSlice({
  name: "cache",
  initialState,
  reducers: {
    clearCacheState: (state) => {
      state.clearCacheLoading = false;
      state.clearCacheError = null;
      state.lastClearResult = null;
    },
  },
  extraReducers: (builder) => {
    // Clear site cache
    builder
      .addCase(clearSiteCache.pending, (state) => {
        state.clearCacheLoading = true;
        state.clearCacheError = null;
      })
      .addCase(clearSiteCache.fulfilled, (state, action) => {
        state.clearCacheLoading = false;
        state.lastClearResult = action.payload;
        state.clearCacheError = null;
      })
      .addCase(clearSiteCache.rejected, (state, action) => {
        state.clearCacheLoading = false;
        state.clearCacheError = action.payload;
      });

    // Clear specific cache
    builder
      .addCase(clearSpecificCache.pending, (state) => {
        state.clearCacheLoading = true;
        state.clearCacheError = null;
      })
      .addCase(clearSpecificCache.fulfilled, (state, action) => {
        state.clearCacheLoading = false;
        state.lastClearResult = action.payload;
        state.clearCacheError = null;
      })
      .addCase(clearSpecificCache.rejected, (state, action) => {
        state.clearCacheLoading = false;
        state.clearCacheError = action.payload;
      });
  },
});

export const { clearCacheState } = cacheSlice.actions;

export default cacheSlice.reducer;
